import React from 'react'

const ArrowRightDownIcon = ({...props}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      {...props}
    >
      <g clipPath='url(#clip0_7482_40349)'>
        <path
          d='M5.00098 5L15.001 15'
          stroke='#666666'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6.87598 15H15.001V6.875'
          stroke='#666666'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_7482_40349'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ArrowRightDownIcon
